export default "__VITE_ASSET__6c835902__"